/**
 * https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/ja.ts
 */

const passwordError = `パスワードの作成条件を満たしていません。
※${process.env.NEXT_PUBLIC_COGNITO_USERPOOL_PASSWORD_MIN_LENGTH}文字以上、英小文字、英大文字、数字、記号をそれぞれ1つ以上使用してください。使用できる記号は以下です。
^ $ * . [ ] { } ( ) ? - " ! @ # % & /  , > < ' : ; | _ ~ \` + =`

export const jaDict = {
  ja: {
    'Sign In': 'ログイン ',
    'Sign in': 'ログイン',
    'Confirm TOTP Code': '認証コード確認',
    'Confirm SMS Code': '認証コード確認',
    'Code *': '認証コード',
    Code: '認証コード',
    'Change Password': 'パスワードの変更',
    'Enter your Username': 'ユーザー名を入力 ', // login input placeholder
    'Incorrect username or password.':
      'ユーザー名またはパスワードが異なります。', // "."がライブラリ標準にはない
    'User is disabled.': 'ユーザー名またはパスワードが異なります。', // ユーザが無効化の場合
    'Invalid code received for user': '認証コードが異なります。', // MFA 認証コード間違い
    'Invalid code or auth state for the user.': '認証コードが異なります。', // SMS 認証コード間違い（SMS送信コードと違う値を入力時に発生）
    'Invalid session for the user, session is expired.':
      '有効期限を過ぎています。ログイン画面からやり直してください。', // MFA 時間経過
    'Your passwords must match': '入力内容が一致していません。', // 初期パスワード変更画面 入力不一致
    'Enter your email': 'メールアドレスを入力', // Eメールログインの場合のパスワード忘れ
    'Invalid verification code provided, please try again.':
      '認証コードが無効です', // パスワード再設定時 認証コードエラー
    'Your software token has already been used once.':
      '使用済みのコードです。新しいコードを入力してください。', // MFA認証ログイン時
    'Password does not conform to policy: Password not long enough':
      passwordError, // パスワードリセット パスワードの長さが不十分
    'Password does not conform to policy: Password must have lowercase characters':
      passwordError, // パスワードリセット パスワードに英小文字が必要
    'Password does not conform to policy: Password must have uppercase characters':
      passwordError, // パスワードリセット パスワードに英大文字が必要
    'Password does not conform to policy: Password must have numeric characters':
      passwordError, // パスワードリセット パスワードに数字が必要
    'Password does not conform to policy: Password must have symbol characters':
      passwordError, // パスワードリセット パスワードに記号が必要
    'Password does not conform to policy: Password must satisfy regular expression pattern: ^\\S.*\\S$':
      passwordError, // パスワードリセット 1文字だけ入力した際に発生
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$":
      passwordError, // パスワードリセット 1文字だけ入力した際に発生
    'Attempt limit exceeded, please try after some time.':
      '試行回数制限を超えました。しばらくしてからお試しください。', // パスワードリセット 試行回数上限
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
      passwordError, // パスワードリセット 256以上文字列
    'Network error': 'ネットワークエラーです。', // cognitoに繋がらない
  },
}
